import {all} from 'redux-saga/effects'
import {combineReducers} from 'redux'

import * as auth from 'src/app/modules/auth'
import * as profile from 'src/app/modules/profileComponent'
import {globalErrorReducer} from 'src/app/modules/errors/redux/reducer'
import * as siteModule from 'src/app/modules/siteSettings'
import * as userManagement from 'src/app/modules/userMgmt'
import * as userRole from 'src/app/modules/userMgmt/components/userRoles'
import * as departments from 'src/app/modules/userMgmt/components/departments'
import * as branch from 'src/app/modules/userMgmt/components/branch'
import * as rolePermission from 'src/app/modules/common'
import * as cms from 'src/app/modules/cms'
import * as banner from 'src/app/modules/cms/components/banner/redux'

import * as textPopup from 'src/app/modules/cms/components/textPopup/redux'
import * as roadBlockPopup from 'src/app/modules/cms/components/roadblockPopup/redux'
import * as mediaManager from 'src/app/modules/common/components/fileManager'
import * as faqCategory from 'src/app/modules/cms/components/faqCategory/redux'
import * as faqManager from 'src/app/modules/cms/components/faqManager/redux'
import * as faqIconType from 'src/app/modules/cms/components/faqCategory/faqIconType/redux'

import * as emailTemplate from 'src/app/modules/cms/components/emailTemplate/redux'
import * as formsDownload from 'src/app/modules/formsAndDownload'
import * as DuplicateCIF from 'src/app/pages/dashboard/redux'

import {link} from 'fs'

import MasterDataSlice from './MasterDataOption'
import ProgressBarSteps from './progressBarStep'
import applicationSlice from './applicationSlice'
import * as accountStatus from 'src/app/modules/accountStatus/redux'

export const rootReducer = combineReducers({
  auth: auth.reducer,
  globalError: globalErrorReducer,
  smtp: siteModule.smtp.reducer,
  key: siteModule.key.reducer,
  groupSetting: siteModule.groupSetting.reducer,
  settingType: siteModule.settings.reducer,
  userManagement: userManagement.reducer,
  module: siteModule.module.reducer,
  permission: rolePermission.reducer,
  place: rolePermission.placeReducer,
  categoryType: rolePermission.categoryTypeReducer,
  customerTestimonialMediaType: rolePermission.mediaTypeReducer,
  role: userManagement.roles.reducer,
  userRoles: userRole.reducer,
  departments: departments.reducer,
  branch: branch.reducer,
  profile: profile.reducer,
  menuManager: cms.menu.reducer,
  content: cms.content.reducer,

  //CMS
  banner: banner.reducer,

  emailTemplate: emailTemplate.reducer,
  textPopup: textPopup.reducer,
  roadBlockPopup: roadBlockPopup.reducer,
  faqCategory: faqCategory.reducer,
  faqManager: faqManager.reducer,

  mediaManager: mediaManager.reducer,
  faqIconType: faqIconType.reducer,

  //Forms and Download
  formsAndDownload: formsDownload.formAndDownload.reducer,
  formsAndDownloadCategory: formsDownload.formAndDownload.reducer1,

  //Contact Person
  contactPerson: siteModule.contactPerson.reducer,

  // Duplicate CIF
  duplicateCifCheck: DuplicateCIF.reducer,

  //Homepage Setting
  homepageSetting: siteModule.homepageSetting.reducer,

  // master Data Slice
  allMasterDataOptions: MasterDataSlice,
  progressBarSteps: ProgressBarSteps,
  application: applicationSlice,
  // account list
  accountStatus: accountStatus.reducer,
})

export type RootState = ReturnType<typeof rootReducer>

export function* rootSaga() {
  yield all([
    auth.saga(),
    siteModule.smtp.saga(),
    siteModule.key.saga(),
    siteModule.settings.saga(),
    siteModule.groupSetting.saga(),
    siteModule.module.saga(),
    userRole.saga(),
    departments.saga(),
    branch.saga(),
    rolePermission.saga(),
    userManagement.saga(),
    userManagement.roles.saga(),
    profile.saga(),
    cms.menu.saga(),
    cms.content.saga(),

    banner.saga(),

    textPopup.saga(),
    roadBlockPopup.saga(),

    mediaManager.saga(),
    faqCategory.saga(),
    faqManager.saga(),
    faqIconType.saga(),

    //Loan
    emailTemplate.saga(),
    formsDownload.formAndDownload.saga(),

    //Contact Person
    siteModule.contactPerson.saga(),

    //Homepage Setting
    siteModule.homepageSetting.saga(),

    // Duplicate CIF
    DuplicateCIF.saga(),

    //account list
    accountStatus.saga(),
  ])
}
